import React, { Component } from 'react'
import loading from './loading.gif'

export class Spinner extends Component {
  render() {
    return (
      <div className="spinner-wrapper">
        <img src={loading} alt="loading"/>
        <span className="spinner-label">Loading articles...</span>
      </div>
    )
  }
}

export default Spinner
